/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as controlAccessControlV1 from "./keyapis_access_control_access_control_v1.pb"

/**
 * Сервис реализует функционал управления связями точек доступа и групп
 */

/**
 * Сервис связей точек доступа и групп
 */
export class AccessPointGroupServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения списка связей точек доступа и групп.
   * Метод доступен для: admin, service, bti
   */
  GetAccessPointGroupList = (req?: GetAccessPointGroupListRequestDto, init?: RequestInit): Promise<GetAccessPointGroupListResponseDto[]> => {
    return fm.list<GetAccessPointGroupListRequestDto, GetAccessPointGroupListResponseDto>(`${this.host}/access_control/api/v1/access_point/group/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества связей точек доступа и групп.
   * Метод доступен для: admin, service, bti
   */
  GetAccessPointGroupCount = (req?: GetAccessPointGroupCountRequestDto, init?: RequestInit): Promise<GetAccessPointGroupCountResponseDto> => {
    return fm.request<GetAccessPointGroupCountRequestDto, GetAccessPointGroupCountResponseDto>(`${this.host}/access_control/api/v1/access_point/group/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод создания связи точки доступа и группы.
   * Метод доступен для: admin, service, bti
   */
  PutAccessPointGroupAttach = (req: PutAccessPointGroupAttachRequestDto, init?: RequestInit): Promise<PutAccessPointGroupAttachResponseDto> => {
    return fm.request<PutAccessPointGroupAttachRequestDto, PutAccessPointGroupAttachResponseDto>(`${this.host}/access_control/api/v1/access_point/${encodeURIComponent(req.accessPointGroup.accessPointId)}/group/${encodeURIComponent(req.accessPointGroup.groupId)}/attach`, { ...init, method: "PUT", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления связи точки доступа и группы.
   * Метод доступен для: admin, service, bti
   */
  PutAccessPointGroupDetach = (req: PutAccessPointGroupDetachRequestDto, init?: RequestInit): Promise<PutAccessPointGroupDetachResponseDto> => {
    return fm.request<PutAccessPointGroupDetachRequestDto, PutAccessPointGroupDetachResponseDto>(`${this.host}/access_control/api/v1/access_point/${encodeURIComponent(req.accessPointGroup.accessPointId)}/group/${encodeURIComponent(req.accessPointGroup.groupId)}/detach`, { ...init, method: "PUT", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Справочник типов направлений сортировки;
 */
export enum AccessPointGroupPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки;
 */
export type AccessPointGroupPagingDirectionTypeResponseEnum = keyof typeof AccessPointGroupPagingDirectionType
/**
 * Справочник типов направлений сортировки;
 */
export type AccessPointGroupPagingDirectionTypeRequestEnum = Exclude<AccessPointGroupPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки.
 */
export enum AccessPointGroupPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По идентификатору группы
   */
  GROUP_ID = "GROUP_ID",
  /**
   * По идентификатору точки доступа
   */
  ACCESS_POINT_ID = "ACCESS_POINT_ID",
  /**
   * По дате создания
   */
  CREATED_AT = "CREATED_AT",
}
/**
 * Справочник типов значений сортировки.
 */
export type AccessPointGroupPagingOrderByTypeResponseEnum = keyof typeof AccessPointGroupPagingOrderByType
/**
 * Справочник типов значений сортировки.
 */
export type AccessPointGroupPagingOrderByTypeRequestEnum = Exclude<AccessPointGroupPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Связка точки доступа и группы.
 * # Описание модели
 */
export type AccessPointGroupRequestDto = {
  /**
   * Идентификатор точки доступа.
   * # Тип: Guid
   */
  accessPointId: string
  /**
   * Идентификатор группы.
   * # Тип: Guid
   */
  groupId: string
}
/**
 * Связка точки доступа и группы.
 * # Описание модели
 */
export type AccessPointGroupResponseDto = {
  /**
   * Идентификатор точки доступа.
   * # Тип: Guid
   */
  accessPointId: string
  /**
   * Идентификатор группы.
   * # Тип: Guid
   */
  groupId: string
}
/**
 * Фильтр по связям точек доступа и групп
 */
export type AccessPointGroupFilterRequestDto = {
  /**
   * По идентификаторам точки доступа.
   * # Тип: Guid
   */
  accessPointIds?: string[]
  /**
   * По идентификаторам группы.
   * # Тип: Guid
   */
  groupIds?: string[]
}
/**
 * Фильтр по связям точек доступа и групп
 */
export type AccessPointGroupFilterResponseDto = {
  /**
   * По идентификаторам точки доступа.
   * # Тип: Guid
   */
  accessPointIds: string[]
  /**
   * По идентификаторам группы.
   * # Тип: Guid
   */
  groupIds: string[]
}
/**
 * Постраничный вывод
 */
export type AccessPointGroupPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: GROUP_ID
   */
  orderByType?: AccessPointGroupPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType?: AccessPointGroupPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Постраничный вывод
 */
export type AccessPointGroupPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: GROUP_ID
   */
  orderByType: AccessPointGroupPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType: AccessPointGroupPagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Запрос получения количества связей точек доступа и групп
 */
export type GetAccessPointGroupCountRequestDto = {
  /**
   * Фильтр
   */
  filter?: AccessPointGroupFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества точек доступа
 */
export type GetAccessPointGroupCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего точек доступа
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: GetAccessPointGroupCountResponseErrorDto
}>
/**
 * Ошибка запроса получения количества точек доступа
 */
export type GetAccessPointGroupCountResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения количества точек доступа
 */
export type GetAccessPointGroupCountResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Запрос на получение списка связей точек доступа и групп
 */
export type GetAccessPointGroupListRequestDto = {
  /**
   * Фильтр
   */
  filter?: AccessPointGroupFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Стандартный постраничный вывод
   */
  readonly paging: AccessPointGroupPagingRequestDto
}>
/**
 * Ответ на получение списка связей точек доступа и групп
 */
export type GetAccessPointGroupListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Связь точки доступа и группы
   */
  readonly data: AccessPointGroupResponseDto
  /**
   * Ошибка
   */
  readonly error: GetAccessPointGroupListResponseErrorDto
}>
/**
 * Ошибка запроса получения списка связей точек доступа и групп
 */
export type GetAccessPointGroupListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения списка связей точек доступа и групп
 */
export type GetAccessPointGroupListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Запрос создания связи точки доступа и группы
 */
export type PutAccessPointGroupAttachRequestDto = {
  /**
   * Связь точки доступа и группы
   */
  accessPointGroup: AccessPointGroupRequestDto
}
/**
 * Ответ на запрос сохранения связи точки доступа и группы
 */
export type PutAccessPointGroupAttachResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PutAccessPointGroupAttachResponseErrorDto
}>
/**
 * Ошибка запроса на создание связи точки доступа и группы
 */
export type PutAccessPointGroupAttachResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса на создание связи точки доступа и группы
 */
export type PutAccessPointGroupAttachResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Запрос удаления связи точки доступа и группы
 */
export type PutAccessPointGroupDetachRequestDto = {
  /**
   * Связь точки доступа и группы
   */
  accessPointGroup: AccessPointGroupRequestDto
}
/**
 * Ответ на запрос удаления связи точки доступа и группы
 */
export type PutAccessPointGroupDetachResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PutAccessPointGroupDetachResponseErrorDto
}>
/**
 * Ошибка запроса на удаление связи точки доступа и группы
 */
export type PutAccessPointGroupDetachResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса на удаление связи точки доступа и группы
 */
export type PutAccessPointGroupDetachResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Связка точки доступа и группы.
   * # Описание модели
   */
  "AccessPointGroup": {
    "kind": "class",
    "text": "Связка точки доступа и группы.\n# Описание модели",
    "fields": {
      /**
       * Идентификатор точки доступа.
       * # Тип: Guid
       */
      "accessPointId": {
        "type": "string",
        "text": "Идентификатор точки доступа.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор группы.
       * # Тип: Guid
       */
      "groupId": {
        "type": "string",
        "text": "Идентификатор группы.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Фильтр по связям точек доступа и групп
   */
  "AccessPointGroupFilter": {
    "kind": "class",
    "text": "Фильтр по связям точек доступа и групп",
    "fields": {
      /**
       * По идентификаторам точки доступа.
       * # Тип: Guid
       */
      "accessPointIds": {
        "type": "string",
        "text": "По идентификаторам точки доступа.\n# Тип: Guid",
      },
      /**
       * По идентификаторам группы.
       * # Тип: Guid
       */
      "groupIds": {
        "type": "string",
        "text": "По идентификаторам группы.\n# Тип: Guid",
      },
    },
  },
  /**
   * Постраничный вывод
   */
  "AccessPointGroupPaging": {
    "kind": "class",
    "text": "Постраничный вывод",
    "fields": {
      /**
       * Тип значения сортировки.
       * Если значение не передано, то будет взято значение по умолчанию.
       * # По умолчанию: GROUP_ID
       */
      "orderByType": {
        "type": "AccessPointGroupPaging.OrderByType",
        "text": "Тип значения сортировки.\nЕсли значение не передано, то будет взято значение по умолчанию.\n# По умолчанию: GROUP_ID",
      },
      /**
       * Тип направления сортировки.
       * # По умолчанию: DESC
       */
      "directionType": {
        "type": "AccessPointGroupPaging.DirectionType",
        "text": "Тип направления сортировки.\n# По умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * # Диапазон: 0..100.
       * # По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\n# Диапазон: 0..100.\n# По умолчанию: 20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Сдвиг.
       * # Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Запрос получения количества связей точек доступа и групп
   */
  "GetAccessPointGroupCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества связей точек доступа и групп",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "AccessPointGroupFilter",
        "text": "Фильтр",
      },
    },
  },
  /**
   * Ответ на запрос получения количества точек доступа
   */
  "GetAccessPointGroupCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества точек доступа",
    "fields": {
      /**
       * Всего точек доступа
       */
      "data": {
        "type": "int32",
        "text": "Всего точек доступа",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetAccessPointGroupCountResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения количества точек доступа
   */
  "GetAccessPointGroupCountResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения количества точек доступа",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос на получение списка связей точек доступа и групп
   */
  "GetAccessPointGroupListRequest": {
    "kind": "class",
    "text": "Запрос на получение списка связей точек доступа и групп",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "AccessPointGroupFilter",
        "text": "Фильтр",
      },
      /**
       * Стандартный постраничный вывод
       */
      "paging": {
        "type": "AccessPointGroupPaging",
        "text": "Стандартный постраничный вывод",
      },
    },
  },
  /**
   * Ответ на получение списка связей точек доступа и групп
   */
  "GetAccessPointGroupListResponse": {
    "kind": "class",
    "text": "Ответ на получение списка связей точек доступа и групп",
    "fields": {
      /**
       * Связь точки доступа и группы
       */
      "data": {
        "type": "AccessPointGroup",
        "text": "Связь точки доступа и группы",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetAccessPointGroupListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения списка связей точек доступа и групп
   */
  "GetAccessPointGroupListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения списка связей точек доступа и групп",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос создания связи точки доступа и группы
   */
  "PutAccessPointGroupAttachRequest": {
    "kind": "class",
    "text": "Запрос создания связи точки доступа и группы",
    "fields": {
      /**
       * Связь точки доступа и группы
       */
      "accessPointGroup": {
        "type": "AccessPointGroup",
        "text": "Связь точки доступа и группы",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос сохранения связи точки доступа и группы
   */
  "PutAccessPointGroupAttachResponse": {
    "kind": "class",
    "text": "Ответ на запрос сохранения связи точки доступа и группы",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PutAccessPointGroupAttachResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса на создание связи точки доступа и группы
   */
  "PutAccessPointGroupAttachResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса на создание связи точки доступа и группы",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос удаления связи точки доступа и группы
   */
  "PutAccessPointGroupDetachRequest": {
    "kind": "class",
    "text": "Запрос удаления связи точки доступа и группы",
    "fields": {
      /**
       * Связь точки доступа и группы
       */
      "accessPointGroup": {
        "type": "AccessPointGroup",
        "text": "Связь точки доступа и группы",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления связи точки доступа и группы
   */
  "PutAccessPointGroupDetachResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления связи точки доступа и группы",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PutAccessPointGroupDetachResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса на удаление связи точки доступа и группы
   */
  "PutAccessPointGroupDetachResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса на удаление связи точки доступа и группы",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки;
   */
  "AccessPointGroupPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки;",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки.
   */
  "AccessPointGroupPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По идентификатору группы
       */
      "GROUP_ID": {
        "i": 1,
        "text": "По идентификатору группы",
      },
      /**
       * По идентификатору точки доступа
       */
      "ACCESS_POINT_ID": {
        "i": 2,
        "text": "По идентификатору точки доступа",
      },
      /**
       * По дате создания
       */
      "CREATED_AT": {
        "i": 3,
        "text": "По дате создания",
      },
    },
  },
}